import styled from "styled-components";

import "../../../../../GlobalStyles/Font.css";

export const OverlayModelWindow = styled.div`
  background: #d9d9d9b3;
  overflow-y: scroll;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export const SignUpModelContainer = styled.div`
  max-width: 326px;
  background: #fff;
  border-radius: 20px;
  padding: 16px 20px;
  margin-bottom: 16px;
  margin-top: 16px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 428px) {
    max-width: 396px;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 1024px) {
    max-width: 309px;
  }

  @media (min-width: 1440px) {
    max-width: 449px;
  }
`;

export const SignUpHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SignUpTitle = styled.h1`
  font-size: 20px;
  font-family: "Exo2 Light";
  line-height: 1.2;

  @media (min-width: 1440px) {
    font-size: 36px;
    line-height: 1.19;
  }
`;

export const CloseButtonModel = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f64747;
  border-radius: 50%;
  padding: 10px;
  width: 40px;
  height: 40px;

  cursor: pointer;

  @media (min-width: 1440px) {
    width: 60px;
    height: 60px;
  }
`;

export const CloseButtonModelIcon = styled.svg`
  width: 20px;
  height: 20px;
  fill: #fff;

  @media (min-width: 1440px) {
    width: 30px;
    height: 30px;
  }
`;

export const SignUpListItem = styled.li`
  margin-top: 20px;

  &:first-child {
    margin-top: 24px;
  }
`;

export const ContainerInput = styled.div`
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 20px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  position: relative;

  transition: 150ms cubic-bezier(0.61, 0, 0.51, 1);

  &.error-animation-input {
    border: 3px solid #e63946;'
    border-radius: 20px;
  }
`;

export const ContainerInputPassword = styled.div`
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 20px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  position: relative;

  margin-top: 20px;

  transition: 150ms cubic-bezier(0.61, 0, 0.51, 1);

  &.error-animation-input {
    border: 3px solid #e63946;
    border-radius: 20px;
    transition: 150ms cubic-bezier(0.61, 0, 0.51, 1);
  }
`;

// add transition for .error-animation-input

export const ButtonPasswordIcon = styled.button`
  position: absolute;
  right: 20px;

  cursor: pointer;
`;

export const TextInput = styled.input`
  font-size: 20px;
  font-family: "Exo2 Medium";
  line-height: 1.2;

  &::placeholder {
    color: #808080;
  }
`;

// errors

export const ErrorTextUser = styled.p`
  color: #f44336;
  font-size: 20px;
  font-family: "Exo2 Medium";
  line-height: 1.2;
  margin-top: 0px;
  margin-left: 4px;
  min-height: 0px;
  opacity: 0;
  transform: translateY(-5px);
  transition: transform 250ms cubic-bezier(0.61, 0, 0.51, 1),
    opacity 250ms cubic-bezier(0.61, 0, 0.51, 1),
    min-height 250ms cubic-bezier(0.61, 0, 0.51, 1);

  &.error-animation {
    font-size: 16px;
    margin-top: 4px;
    min-height: 15px;
    opacity: 1;
    transform: translateY(5px);
    transition: transform 250ms cubic-bezier(0.61, 0, 0.51, 1),
      opacity 250ms cubic-bezier(0.61, 0, 0.51, 1),
      min-height 250ms cubic-bezier(0.61, 0, 0.51, 1);
  }

  @media (min-width: 428px) {
    &.error-animation {
      font-size: 20px;
    }
  }
`;

interface IndicatorProps {
  width: number;
  color: string;
}

export const IndicatorPassword = styled.span<IndicatorProps>`
  height: 20px;

  /* показуємо повну білу смужку, якщо немає введення */
  width: ${(p) => (p.width === 0 ? "100%" : p.width + "%")};
  background: ${(p) => (p.width === 0 ? "#fff" : p.color)};

  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  transition: 0.3s ease;
`;

export const SignUpUserIcon = styled.svg`
  width: 24px;
  height: 24px;
  position: absolute;
  right: 20px;
`;

export const SignUpEmailUserIcon = styled.svg`
  width: 24px;
  height: 24px;
  position: absolute;
  right: 20px;
`;

export const ContainerIncludeValidation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 30px;
`;

export const SignUpPasswordIncludeTitle = styled.h2`
  font-size: 24px;
  font-family: "Exo2 Light";
  line-height: 1.2;
`;

export const PasswordValidation = styled.span`
  font-size: 24px;
  font-family: "Exo2 Light";
  line-height: 1.2;
`;

export const SubmitFormButton = styled.input`
  background: #1a50c6;
  border-radius: 20px;
  font-size: 20px;
  font-family: "Exo2 SemiBold";
  line-height: 1.2;
  color: #fff;
  width: 100%;
  padding: 20px 0px 20px;
  margin-top: 34px;

  cursor: pointer;
`;
